<div class="app-shell">
@if (loading.isLoading() || jobs.isProcessing()) {
  <div class="app-loader" role="status" aria-live="polite">
    <mat-spinner [diameter]="56" />
    <span class="app-loader__text">
      @if (jobs.isProcessing()) {
        {{ jobs.phaseLabel() }}… {{ jobs.phaseDetail() }}
      } @else {
        Loading…
      }
    </span>
  </div>
}
  <app-header />
  <app-step-nav />

  <main class="app-shell__content">
    <router-outlet />
  </main>
    <nav class="step-actions">
    <button
      class="step-actions__btn"
      [disabled]="!prevStep()"
      (click)="goTo(prevStep()!.path)"
    >
      <mat-icon>chevron_left</mat-icon>
      <span>{{ prevStep() ?'Previous': 'Previous' }}</span>
    </button>

    <button
      class="step-actions__btn step-actions__btn--primary"
      [disabled]="!nextStep() || nextLocked()"
      [title]="nextLocked() ? 'Upload both files first' : ''"
      (click)="goTo(nextStep()!.path)"
    >
      <span>{{ nextStep() ? 'Next' : 'Finish' }}</span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  </nav>
    <app-footer />

</div>
